import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-accent-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-500 text-accent-950">
                <i className="ri-water-flash-fill text-xl" />
              </span>
              <span className="font-display text-2xl text-background-50">黑瓜吃料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/90">
              瓜田连线，边吃边聊不落单。我们把同一条话题下散落的观点聚在一起，让围观这件事变得更有参与感。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href="mailto:hello@heiguachiliao.com"
                rel="nofollow"
                className="flex items-center gap-2 rounded-md border border-background-200/30 px-3 py-2 text-sm text-background-100 transition-colors hover:border-accent-300 hover:text-accent-200"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-mail-line text-sm" />
                </span>
                hello@heiguachiliao.com
              </a>
              <Link
                to="/about#connect"
                className="flex items-center gap-2 rounded-md bg-accent-500 px-3 py-2 text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-send-plane-fill text-sm" />
                </span>
                投稿连线
              </Link>
            </div>
          </div>

          <nav className="md:col-span-3" aria-label="话题分类导航">
            <h2 className="text-sm font-semibold tracking-wide text-background-50">话题分类</h2>
            <ul className="mt-4 flex flex-col gap-3">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-200/85 transition-colors hover:text-accent-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="md:col-span-4" aria-label="站内导航">
            <h2 className="text-sm font-semibold tracking-wide text-background-50">站内导航</h2>
            <ul className="mt-4 flex flex-col gap-3">
              <li>
                <Link to="/" className="text-sm text-background-200/85 transition-colors hover:text-accent-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-200/85 transition-colors hover:text-accent-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#voices" className="text-sm text-background-200/85 transition-colors hover:text-accent-200">
                  围观口碑
                </Link>
              </li>
              <li>
                <Link to="/about#faq" className="text-sm text-background-200/85 transition-colors hover:text-accent-200">
                  常见问题
                </Link>
              </li>
            </ul>
            <p className="mt-6 text-xs leading-relaxed text-background-300/70">
              本站内容为网友讨论与观点整理，仅供交流参考。欢迎理性围观，友善发言。
            </p>
          </nav>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200/20 pt-6 text-xs text-background-300/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑瓜吃料 · 瓜田连线讨论社区</p>
          <p className="flex items-center gap-1.5">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-plant-line text-xs" />
            </span>
            边吃边聊不落单
          </p>
        </div>
      </div>
    </footer>
  );
}